(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catalog-card-media"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.BeeCatalogCardMediaReady) return;
    window.BeeCatalogCardMediaReady = true;

    let activeVideoButton = null;
    let lastFocusedElement = null;
    let audioState = null;

    const playSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
    const pauseSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 5h4v14H6zm8 0h4v14h-4z"/></svg>';
    const shareSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 10.5l6.8-4M8.6 13.5l6.8 4"/></svg>';

    function formatTime(seconds) {
      if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
      const minutes = Math.floor(seconds / 60);
      const remainder = Math.floor(seconds % 60).toString().padStart(2, '0');
      return `${minutes}:${remainder}`;
    }

    function showToast(message) {
      const toast = document.createElement('div');
      toast.className = 'bee-catalog-toast';
      toast.textContent = message;
      document.body.appendChild(toast);
      requestAnimationFrame(() => toast.classList.add('is-visible'));
      setTimeout(() => {
        toast.classList.remove('is-visible');
        setTimeout(() => toast.remove(), 220);
      }, 1900);
    }

    function readPlaylist(button, selector) {
      const controls = button.closest('.bee-catalog-media-controls');
      const source = controls && controls.querySelector(selector);
      if (!source) return [];
      try {
        return JSON.parse(source.textContent).filter((item) => item && item.url);
      } catch (error) {
        console.warn('Catalog media playlist could not be read.', error);
        return [];
      }
    }

    function productData(button) {
      const controls = button.closest('.bee-catalog-media-controls');
      const relativeUrl = controls ? controls.dataset.productUrl || '' : '';
      return {
        title: controls ? (controls.dataset.productTitle || '').trim() : '',
        description: controls ? (controls.dataset.productDescription || '').trim() : '',
        price: controls ? (controls.dataset.productPrice || '').trim() : '',
        comparePrice: controls ? (controls.dataset.productComparePrice || '').trim() : '',
        image: controls ? (controls.dataset.productImage || '').trim() : '',
        shopName: controls ? (controls.dataset.shopName || '').trim() : '',
        storyLogo: controls ? (controls.dataset.storyLogo || '').trim() : '',
        url: relativeUrl ? new URL(relativeUrl, window.location.origin).href : window.location.href
      };
    }

    function loadImage(url) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = new URL(url, window.location.origin).href;
      });
    }

    function roundedRect(context, x, y, width, height, radius) {
      const r = Math.min(radius, width / 2, height / 2);
      context.beginPath();
      context.moveTo(x + r, y);
      context.arcTo(x + width, y, x + width, y + height, r);
      context.arcTo(x + width, y + height, x, y + height, r);
      context.arcTo(x, y + height, x, y, r);
      context.arcTo(x, y, x + width, y, r);
      context.closePath();
    }

    function drawContain(context, image, x, y, width, height) {
      const scale = Math.min(width / image.width, height / image.height);
      const renderedWidth = image.width * scale;
      const renderedHeight = image.height * scale;
      const renderedX = x + (width - renderedWidth) / 2;
      const renderedY = y + (height - renderedHeight) / 2;
      context.drawImage(image, renderedX, renderedY, renderedWidth, renderedHeight);
    }

    function textLines(context, text, maxWidth, maxLines) {
      const words = text.split(/\s+/).filter(Boolean);
      const lines = [];
      let line = '';
      words.forEach((word) => {
        const test = line ? `${line} ${word}` : word;
        if (context.measureText(test).width <= maxWidth || !line) {
          line = test;
        } else if (lines.length < maxLines - 1) {
          lines.push(line);
          line = word;
        }
      });
      if (line && lines.length < maxLines) lines.push(line);
      if (words.length && lines.length === maxLines) {
        while (context.measureText(`${lines[maxLines - 1]}…`).width > maxWidth) {
          lines[maxLines - 1] = lines[maxLines - 1].slice(0, -1);
        }
      }
      return lines;
    }

    let quicksandLoadPromise = null;
    function ensureQuicksandFont() {
      if (quicksandLoadPromise) return quicksandLoadPromise;
      quicksandLoadPromise = (async () => {
        const quicksandFaces = Array.from(document.fonts).filter(face => face.family.replace(/["']/g, '').toLowerCase() === 'quicksand');
        const weightsReady = [500, 600, 700].every(weight => quicksandFaces.some(face => {
          const range = face.weight.split(' ').map(Number);
          return range.length === 2 ? weight >= range[0] && weight <= range[1] : range[0] === weight;
        }));
        if (!weightsReady && !document.querySelector('link[data-bee-quicksand]')) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://fonts.googleapis.com/css2?family=Quicksand:wght@500;600;700&display=swap';
          link.setAttribute('data-bee-quicksand', '');
          document.head.appendChild(link);
        }
        try {
          await Promise.all([
            document.fonts.load('500 40px Quicksand'),
            document.fonts.load('600 40px Quicksand'),
            document.fonts.load('700 40px Quicksand')
          ]);
        } catch (error) {}
      })();
      return quicksandLoadPromise;
    }

    function drawAudioBadge(context, x, y) {
      const label = 'Audio nümunəsi';
      context.font = '600 26px Quicksand, -apple-system, sans-serif';
      const paddingX = 20;
      const iconAreaWidth = 42;
      const textWidth = context.measureText(label).width;
      const pillHeight = 56;
      const pillWidth = paddingX + iconAreaWidth + textWidth + paddingX;

      roundedRect(context, x, y, pillWidth, pillHeight, pillHeight / 2);
      context.fillStyle = 'rgba(217,96,13,.08)';
      context.fill();

      const barHeights = [14, 26, 18];
      const barWidth = 5;
      const barGap = 5;
      const iconX = x + paddingX;
      const centerY = y + pillHeight / 2;
      context.fillStyle = '#d9600d';
      barHeights.forEach((height, index) => {
        const barX = iconX + index * (barWidth + barGap);
        roundedRect(context, barX, centerY - height / 2, barWidth, height, barWidth / 2);
        context.fill();
      });

      context.fillStyle = '#8a4a12';
      context.textBaseline = 'middle';
      context.fillText(label, iconX + iconAreaWidth, centerY);
      context.textBaseline = 'alphabetic';

      return pillWidth;
    }

    async function createStoryFile(product) {
      await ensureQuicksandFont();

      const canvas = document.createElement('canvas');
      canvas.width = 1080;
      canvas.height = 1920;
      const context = canvas.getContext('2d');
      const FONT = 'Quicksand, -apple-system, BlinkMacSystemFont, sans-serif';

      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, 1080, 1920);

      /* Soft brand shapes keep the Story interesting without putting the
         white product image inside another visible frame. */
      context.fillStyle = '#faf4ef';
      context.beginPath();
      context.arc(-70, 90, 340, 0, Math.PI * 2);
      context.fill();
      context.fillStyle = '#f8eee7';
      context.beginPath();
      context.arc(1080, 1540, 390, 0, Math.PI * 2);
      context.fill();
      drawAudioBadge(context, 58, 64);

      if (product.storyLogo) {
        try {
          const logo = await loadImage(product.storyLogo);
          drawContain(context, logo, 740, 26, 220, 158);
        } catch (error) {}
      }
      context.fillStyle = '#6f1f30';
      context.font = `700 28px ${FONT}`;
      context.textAlign = 'center';
      context.fillText('royal.az', 850, 218);
      context.textAlign = 'left';

      /* The product is drawn directly onto the white Story background.
         Its own white image background therefore blends in naturally. */
      if (product.image) {
        try {
          const image = await loadImage(product.image);
          drawContain(context, image, 48, 238, 984, 900);
        } catch (error) {}
      }

      context.strokeStyle = '#eee7e1';
      context.lineWidth = 2;
      context.beginPath();
      context.moveTo(62, 1172);
      context.lineTo(1018, 1172);
      context.stroke();

      const contentX = 64;
      const contentWidth = 952;
      context.fillStyle = '#201c1a';
      context.font = `700 52px ${FONT}`;
      const titleLines = textLines(context, product.title || 'Musiqi aləti', contentWidth, 2);
      titleLines.forEach((line, index) => context.fillText(line, contentX, 1260 + index * 62));
      const titleBottom = 1260 + (titleLines.length - 1) * 62;

      const priceY = titleBottom + 86;
      context.fillStyle = '#d9600d';
      context.font = `700 48px ${FONT}`;
      context.fillText(product.price || '', contentX, priceY);

      if (product.comparePrice) {
        const priceWidth = context.measureText(product.price || '').width;
        const compareX = contentX + priceWidth + 28;
        context.fillStyle = '#a89d92';
        context.font = `500 29px ${FONT}`;
        context.fillText(product.comparePrice, compareX, priceY - 3);
        const compareWidth = context.measureText(product.comparePrice).width;
        context.strokeStyle = '#a89d92';
        context.lineWidth = 2;
        context.beginPath();
        context.moveTo(compareX, priceY - 15);
        context.lineTo(compareX + compareWidth, priceY - 15);
        context.stroke();
      }

      context.fillStyle = '#81756c';
      context.font = `500 27px ${FONT}`;
      const description = (product.description || 'Alətin real səsini dinlə.').replace(/\s+/g, ' ').trim();
      const descriptionLines = textLines(context, description, contentWidth, 2);
      const detailsLabel = 'Ətraflı →';
      const descriptionWasCut = description.length > descriptionLines.join(' ').length;
      const lastDescriptionIndex = Math.max(descriptionLines.length - 1, 0);
      let lastDescriptionLine = descriptionLines[lastDescriptionIndex] || '';
      if (descriptionWasCut) lastDescriptionLine = `${lastDescriptionLine.replace(/…$/, '')}…`;
      while (lastDescriptionLine.length > 3 && context.measureText(`${lastDescriptionLine}  ${detailsLabel}`).width > contentWidth) {
        lastDescriptionLine = `${lastDescriptionLine.replace(/…$/, '').slice(0, -1).trim()}…`;
      }
      descriptionLines.forEach((line, index) => {
        if (index < lastDescriptionIndex) {
          context.fillStyle = '#81756c';
          context.fillText(line, contentX, priceY + 62 + index * 38);
        }
      });
      const lastDescriptionY = priceY + 62 + lastDescriptionIndex * 38;
      context.fillStyle = '#81756c';
      context.fillText(lastDescriptionLine, contentX, lastDescriptionY);
      const detailsX = contentX + context.measureText(`${lastDescriptionLine}  `).width;
      context.fillStyle = '#d9600d';
      context.font = `600 27px ${FONT}`;
      context.fillText(detailsLabel, detailsX, lastDescriptionY);

      const actionY = 1655;
      roundedRect(context, 64, actionY, 430, 112, 56);
      const buttonGradient = context.createLinearGradient(64, actionY, 494, actionY + 112);
      buttonGradient.addColorStop(0, '#e9872d');
      buttonGradient.addColorStop(1, '#d9600d');
      context.fillStyle = buttonGradient;
      context.fill();
      context.fillStyle = '#fff';
      context.beginPath();
      context.arc(124, actionY + 56, 29, 0, Math.PI * 2);
      context.strokeStyle = '#fff';
      context.lineWidth = 3;
      context.stroke();
      context.beginPath();
      context.moveTo(117, actionY + 42);
      context.lineTo(117, actionY + 70);
      context.lineTo(138, actionY + 56);
      context.closePath();
      context.fill();
      context.font = `700 30px ${FONT}`;
      context.fillText('SƏSİNİ DİNLƏ', 174, actionY + 67);

      /* The right side beside the audio CTA is intentionally left empty so
         the Instagram Link sticker can be positioned there after sharing. */

      context.fillStyle = '#a3968d';
      context.font = `500 23px ${FONT}`;
      context.fillText(new URL(product.url).hostname, 64, 1850);
      context.textAlign = 'right';
      context.fillText('Royal · Musiqi alətləri mağazası', 1016, 1850);
      context.textAlign = 'left';

      const blob = await new Promise((resolve, reject) => {
        canvas.toBlob((result) => result ? resolve(result) : reject(new Error('Story image failed')), 'image/png', .95);
      });
      return new File([blob], 'royal-az-story.png', { type: 'image/png' });
    }

    function closeAudioPlayer() {
      const player = document.querySelector('.bee-catalog-audio-player');
      if (audioState) {
        audioState.audio.pause();
        audioState.button.setAttribute('aria-pressed', 'false');
      }
      audioState = null;
      if (player) player.remove();
    }

    function openAudioPlayer(button, playlist) {
      closeAudioPlayer();
      const product = productData(button);

      const player = document.createElement('div');
      player.className = 'bee-catalog-audio-player';
      player.setAttribute('role', 'region');
      player.setAttribute('aria-label', 'Audio player');
      player.innerHTML = `
        <button type="button" class="bee-catalog-audio-action" aria-label="Oxut və ya dayandır">${pauseSvg}</button>
        <div class="bee-catalog-audio-body">
          <div class="bee-catalog-audio-toprow">
            <div class="bee-catalog-audio-title"></div>
            <span class="bee-catalog-audio-time"><span class="bee-catalog-audio-current">0:00</span> / <span class="bee-catalog-audio-duration">0:00</span></span>
          </div>
          <div class="bee-catalog-audio-track">
            <input class="bee-catalog-audio-seek" type="range" min="0" max="0" value="0" step="0.1" aria-label="Audio vaxtı">
            <span class="bee-catalog-audio-track-fill"></span>
            <span class="bee-catalog-audio-track-thumb"></span>
          </div>
          <div class="bee-catalog-audio-tools">
            <select class="bee-catalog-audio-select" aria-label="Audio janrını seç"></select>
            <button type="button" class="bee-catalog-audio-share" aria-label="Məhsulu paylaş">${shareSvg}<span>Paylaş</span></button>
          </div>
        </div>
        <button type="button" class="bee-catalog-audio-close" aria-label="Audio player-i bağla"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button>
        <div class="bee-catalog-audio-share-menu" hidden>
          <button type="button" class="bee-catalog-audio-share-option" data-share-kind="native"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 10.5l6.8-4M8.6 13.5l6.8 4"/></svg><span>Paylaş…</span></button>
          <button type="button" class="bee-catalog-audio-share-option" data-share-kind="instagram"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg><span>Instagram Story</span></button>
          <button type="button" class="bee-catalog-audio-share-option" data-share-kind="whatsapp"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.5 11.8a8.5 8.5 0 0 1-12.6 7.5L3 20.6l1.3-4.7A8.5 8.5 0 1 1 20.5 11.8Z"/><path d="M8.2 7.8c.2-.4.4-.4.7-.4h.4c.2 0 .4 0 .5.4l.8 1.9c.1.3 0 .5-.2.7l-.6.7c-.2.2-.1.4 0 .6.7 1.3 1.8 2.3 3.1 2.9.2.1.4.1.6-.1l.8-1c.2-.2.4-.3.7-.2l1.8.9c.3.1.4.3.4.5 0 .5-.3 1.5-1 2-.6.5-1.4.7-2.3.5-1.1-.3-2.6-.9-4.3-2.4-2-1.8-3.2-4-3.3-5.2-.1-.8.2-1.5.6-1.9.4-.4.8-.5 1.3-.5Z"/></svg><span>WhatsApp</span></button>
          <button type="button" class="bee-catalog-audio-share-option" data-share-kind="telegram"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m21 4-3.2 15.2c-.2 1-1 1.2-1.8.7l-4.9-3.6-2.4 2.3c-.3.3-.5.5-1 .5l.4-5 9-8.1c.4-.4-.1-.6-.6-.2L5.3 12.9.5 11.4c-1-.3-1.1-1 .2-1.5L19.5 2.7C20.4 2.4 21.2 2.9 21 4Z"/></svg><span>Telegram</span></button>
          <button type="button" class="bee-catalog-audio-share-option" data-share-kind="copy"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7-7l-1.1 1.1M14 11a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7 7l1.1-1.1"/></svg><span>Linki kopyala</span></button>
        </div>
      `;
      const titleElement = player.querySelector('.bee-catalog-audio-title');
      titleElement.textContent = product.title || 'Audio nümunəsi';
      titleElement.title = product.title || 'Audio nümunəsi';
      document.body.appendChild(player);

      const action = player.querySelector('.bee-catalog-audio-action');
      const seek = player.querySelector('.bee-catalog-audio-seek');
      const current = player.querySelector('.bee-catalog-audio-current');
      const duration = player.querySelector('.bee-catalog-audio-duration');
      const fill = player.querySelector('.bee-catalog-audio-track-fill');
      const thumb = player.querySelector('.bee-catalog-audio-track-thumb');
      const select = player.querySelector('.bee-catalog-audio-select');
      const share = player.querySelector('.bee-catalog-audio-share');
      const shareMenu = player.querySelector('.bee-catalog-audio-share-menu');
      const close = player.querySelector('.bee-catalog-audio-close');

      playlist.forEach((item, index) => {
        const option = document.createElement('option');
        option.value = String(index);
        option.textContent = item.genre || `Audio ${index + 1}`;
        select.appendChild(option);
      });
      if (playlist.length < 2) select.hidden = true;

      audioState = {
        button,
        playlist,
        index: 0,
        audio: new Audio(),
        player,
        storyPromise: null
      };

      function syncPlayer() {
        if (!audioState || audioState.player !== player) return;
        const audio = audioState.audio;
        current.textContent = formatTime(audio.currentTime);
        duration.textContent = formatTime(audio.duration);
        const max = Number.isFinite(audio.duration) ? audio.duration : 0;
        seek.max = max;
        seek.value = audio.currentTime || 0;
        const percent = max > 0 ? (audio.currentTime / max) * 100 : 0;
        fill.style.width = percent + '%';
        thumb.style.left = percent + '%';
        const playing = !audio.paused && !audio.ended;
        action.innerHTML = playing ? pauseSvg : playSvg;
        button.setAttribute('aria-pressed', playing ? 'true' : 'false');
      }

      function loadTrack(index, autoplay) {
        if (!audioState || audioState.player !== player) return;
        audioState.audio.pause();
        audioState.index = index;
        select.value = String(index);
        const audio = new Audio(playlist[index].url);
        audio.preload = 'metadata';
        audioState.audio = audio;
        audio.ontimeupdate = syncPlayer;
        audio.onloadedmetadata = syncPlayer;
        audio.onplay = syncPlayer;
        audio.onpause = syncPlayer;
        audio.onended = () => {
          if (!audioState || audioState.player !== player) return;
          if (audioState.index < playlist.length - 1) {
            loadTrack(audioState.index + 1, true);
          } else {
            loadTrack(0, true);
          }
        };
        syncPlayer();
        if (autoplay) {
          audio.play().catch(() => syncPlayer());
        }
      }

      action.addEventListener('click', () => {
        const audio = audioState.audio;
        if (audio.paused) {
          audio.play().catch(() => {});
        } else {
          audio.pause();
        }
        syncPlayer();
      });
      seek.addEventListener('input', () => {
        audioState.audio.currentTime = Number(seek.value);
        syncPlayer();
      });
      select.addEventListener('change', () => loadTrack(Number(select.value), true));
      share.addEventListener('click', () => {
        shareMenu.hidden = !shareMenu.hidden;
        // Prepare only when sharing is requested, not while listening to audio.
        if (!shareMenu.hidden && audioState && audioState.player === player && !audioState.storyPromise) {
          audioState.storyPromise = createStoryFile(product).catch(() => null);
        }
      });
      shareMenu.addEventListener('click', async (event) => {
        const option = event.target.closest('[data-share-kind]');
        if (!option) return;
        const kind = option.dataset.shareKind;
        const text = `${product.title || 'Bu məhsul'} — səsini dinlə`;
        if (kind === 'instagram') {
          showToast('Story hazırlanır…');
          try {
            const file = await audioState.storyPromise;
            if (!file) throw new Error('Story image failed');
            if (navigator.share && (!navigator.canShare || navigator.canShare({ files: [file] }))) {
              await navigator.share({ files: [file], title: product.title, text });
              showToast('Paylaşım açıldı');
            } else {
              const download = document.createElement('a');
              download.href = URL.createObjectURL(file);
              download.download = file.name;
              download.click();
              URL.revokeObjectURL(download.href);
              showToast('Story şəkli endirildi');
            }
          } catch (error) {
            showToast('Story hazırlamaq olmadı');
          }
        } else if (kind === 'native' && navigator.share) {
          try { await navigator.share({ title: product.title, text, url: product.url }); } catch (error) {}
        } else if (kind === 'whatsapp') {
          window.open(`https://wa.me/?text=${encodeURIComponent(`${text} ${product.url}`)}`, '_blank', 'noopener');
        } else if (kind === 'telegram') {
          window.open(`https://t.me/share/url?url=${encodeURIComponent(product.url)}&text=${encodeURIComponent(text)}`, '_blank', 'noopener');
        } else {
          try {
            await navigator.clipboard.writeText(product.url);
            showToast('Link kopyalandı');
          } catch (error) {
            showToast('Linki kopyalamaq olmadı');
          }
        }
        shareMenu.hidden = true;
      });
      close.addEventListener('click', closeAudioPlayer);
      loadTrack(0, true);
    }

    function resetButton(button) {
      if (audioState && audioState.button === button) audioState.audio.pause();
      button.setAttribute('aria-pressed', 'false');
    }

    function stopOtherMedia(activeButton) {
      document.querySelectorAll('[data-catalog-media-button][aria-pressed="true"]').forEach((button) => {
        if (button !== activeButton) resetButton(button);
      });
    }

    function youtubeEmbedUrl(source) {
      try {
        const url = new URL(source, window.location.origin);
        let videoId = '';
        if (url.hostname.includes('youtu.be')) {
          videoId = url.pathname.split('/').filter(Boolean)[0] || '';
        } else if (url.hostname.includes('youtube.com') || url.hostname.includes('youtube-nocookie.com')) {
          videoId = url.searchParams.get('v') || '';
          if (!videoId && url.pathname.includes('/embed/')) {
            videoId = url.pathname.split('/embed/')[1].split('/')[0];
          }
          if (!videoId && url.pathname.includes('/shorts/')) {
            videoId = url.pathname.split('/shorts/')[1].split('/')[0];
          }
        }
        return videoId ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0` : '';
      } catch (error) {
        return '';
      }
    }

    function closeVideoModal() {
      const modal = document.querySelector('.bee-catalog-video-modal');
      const shouldRestoreFocus = Boolean(modal);
      if (modal) modal.remove();
      if (activeVideoButton) activeVideoButton.setAttribute('aria-pressed', 'false');
      activeVideoButton = null;
      document.documentElement.style.removeProperty('overflow');
      if (shouldRestoreFocus && lastFocusedElement) lastFocusedElement.focus();
      lastFocusedElement = null;
    }

    function openVideoModal(button, playlist) {
      closeVideoModal();
      lastFocusedElement = button;
      activeVideoButton = button;

      const modal = document.createElement('div');
      modal.className = 'bee-catalog-video-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Məhsul videosu');

      const shell = document.createElement('div');
      shell.className = 'bee-catalog-video-shell';

      const toolbar = document.createElement('div');
      toolbar.className = 'bee-catalog-video-toolbar';

      const videoSelect = document.createElement('select');
      videoSelect.className = 'bee-catalog-video-select';
      videoSelect.setAttribute('aria-label', 'Videonu seç');
      playlist.forEach((item, index) => {
        const option = document.createElement('option');
        option.value = String(index);
        option.textContent = item.label || `Video ${index + 1}`;
        videoSelect.appendChild(option);
      });
      if (playlist.length < 2) videoSelect.hidden = true;

      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'bee-catalog-video-close';
      close.setAttribute('aria-label', 'Videonu bağla');
      close.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';

      const dialog = document.createElement('div');
      dialog.className = 'bee-catalog-video-dialog';

      function renderVideo(index) {
        const source = playlist[index].url;
        const embedUrl = youtubeEmbedUrl(source);
        let media;
        if (embedUrl) {
          media = document.createElement('iframe');
          media.src = embedUrl;
          media.allow = 'autoplay; encrypted-media; picture-in-picture';
          media.allowFullscreen = true;
          media.title = playlist[index].label || 'Məhsul videosu';
        } else {
          media = document.createElement('video');
          media.src = source;
          media.controls = true;
          media.autoplay = true;
          media.playsInline = true;
        }
        media.className = 'bee-catalog-video-frame';
        dialog.replaceChildren(media);
      }

      toolbar.append(videoSelect, close);
      shell.append(toolbar, dialog);
      renderVideo(0);
      videoSelect.addEventListener('change', () => renderVideo(Number(videoSelect.value)));

      const product = productData(button);
      const { title, description, price, comparePrice } = product;
      const productUrl = product.url;

      if (title || description || price || productUrl) {
        const info = document.createElement('div');
        info.className = 'bee-catalog-video-info';

        if (title) {
          const infoTitle = document.createElement('p');
          infoTitle.className = 'bee-catalog-video-info-title';
          infoTitle.textContent = title;
          info.appendChild(infoTitle);
        }

        if (price) {
          const priceRow = document.createElement('div');
          priceRow.className = 'bee-catalog-video-info-price';
          const current = document.createElement('span');
          current.className = 'bee-catalog-video-info-price-current';
          current.textContent = price;
          priceRow.appendChild(current);
          if (comparePrice) {
            const compare = document.createElement('span');
            compare.className = 'bee-catalog-video-info-price-compare';
            compare.textContent = comparePrice;
            priceRow.appendChild(compare);
          }
          info.appendChild(priceRow);
        }

        if (description) {
          const infoDesc = document.createElement('p');
          infoDesc.className = 'bee-catalog-video-info-desc';
          infoDesc.textContent = description;
          info.appendChild(infoDesc);
        }

        {
          const actions = document.createElement('div');
          actions.className = 'bee-catalog-video-info-actions';

          if (productUrl) {
            const cta = document.createElement('a');
            cta.className = 'bee-catalog-video-cta';
            cta.href = productUrl;
            cta.innerHTML = 'Ətraflı bax <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg>';
            actions.appendChild(cta);
          }

          const whatsappNumber = '994504040999';
          const whatsappMessage = 'Salam, ' + (title || 'bu məhsul') + ' haqqında məlumat almaq istəyirəm.';
          const whatsapp = document.createElement('a');
          whatsapp.className = 'bee-catalog-video-cta bee-catalog-video-cta--whatsapp';
          whatsapp.href = 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(whatsappMessage);
          whatsapp.target = '_blank';
          whatsapp.rel = 'noopener';
          whatsapp.innerHTML = 'WhatsApp <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.29-1.39a9.9 9.9 0 0 0 4.75 1.21h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm5.8 14.02c-.24.68-1.4 1.3-1.93 1.38-.5.08-1.11.11-1.79-.11-.41-.13-.94-.31-1.62-.6-2.85-1.23-4.71-4.1-4.85-4.29-.14-.19-1.16-1.54-1.16-2.94s.73-2.08.99-2.36c.26-.29.56-.36.75-.36h.53c.17 0 .39-.03.61.46.24.56.79 1.96.86 2.1.07.14.11.31.02.5-.09.19-.14.31-.27.48-.14.17-.29.38-.41.51-.14.14-.28.3-.12.58.16.28.71 1.16 1.52 1.88 1.05.93 1.93 1.22 2.21 1.36.28.14.44.11.6-.07.17-.18.71-.83.9-1.11.19-.28.38-.24.63-.14.26.09 1.65.78 1.93.92.28.14.47.21.53.33.07.12.07.68-.17 1.36z"/></svg>';
          actions.appendChild(whatsapp);

          info.appendChild(actions);
        }

        shell.appendChild(info);
      }

      modal.appendChild(shell);
      document.body.appendChild(modal);
      document.documentElement.style.overflow = 'hidden';
      button.setAttribute('aria-pressed', 'true');
      close.focus();

      close.addEventListener('click', closeVideoModal);
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeVideoModal();
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && document.querySelector('.bee-catalog-video-modal')) {
        closeVideoModal();
      }
    });

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-catalog-media-button]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      if (button.dataset.catalogMediaButton === 'video') {
        const playlist = readPlaylist(button, '[data-video-playlist]');
        if (!playlist.length) return;
        closeAudioPlayer();
        stopOtherMedia(button);
        openVideoModal(button, playlist);
        return;
      }

      if (audioState && audioState.button === button) {
        if (audioState.audio.paused) {
          audioState.audio.play().catch(() => {});
        } else {
          audioState.audio.pause();
        }
        return;
      }

      closeVideoModal();
      stopOtherMedia(button);
      const playlist = readPlaylist(button, '[data-audio-playlist]');
      if (playlist.length) openAudioPlayer(button, playlist);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["royal-header-search"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (root) => {
      if (root.dataset.royalSearchReady === 'true') return;

      const trigger = root.querySelector('[data-royal-search-trigger]');
      const panel = root.querySelector('[data-royal-search-panel]');
      const input = root.querySelector('[data-royal-search-input]');
      const form = root.querySelector('[data-royal-search-form]');
      const isToolbar = root.classList.contains('royal-header-search--toolbar');

      if (!trigger || !panel || !input || !form) return;
      root.dataset.royalSearchReady = 'true';

      const open = () => {
        if (isToolbar && panel.parentElement !== document.body) document.body.appendChild(panel);
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        // Keep focus in the trusted click: mobile keyboards may reject delayed focus.
        input.getBoundingClientRect();
        input.focus({ preventScroll: true });
      };

      const close = (restoreFocus = false) => {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (isToolbar && panel.parentElement !== root) root.appendChild(panel);
        if (restoreFocus) trigger.focus({ preventScroll: true });
      };

      trigger.addEventListener('click', () => {
        if (panel.hidden) {
          open();
        } else {
          close(true);
        }
      });

      form.addEventListener('submit', (event) => {
        if (!input.value.trim()) {
          event.preventDefault();
          input.focus({ preventScroll: true });
        }
      });

      form.addEventListener('reset', () => {
        input.focus({ preventScroll: true });
      });

      document.addEventListener('pointerdown', (event) => {
        if (!panel.hidden && !root.contains(event.target) && !panel.contains(event.target)) close(false);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) close(true);
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-royal-header-search]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["royal-home-categories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('royal-categories-slider')) {
    class RoyalCategoriesSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-royal-categories-track]');
        this.previousButton = this.querySelector('[data-royal-categories-previous]');
        this.nextButton = this.querySelector('[data-royal-categories-next]');
        this.progressBar = this.querySelector('[data-royal-categories-progress]');

        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.handlePrevious = () => this.scrollByPage(-1);
        this.handleNext = () => this.scrollByPage(1);
        this.handleScroll = () => window.requestAnimationFrame(() => this.updateControls());
        this.handleKeydown = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

          event.preventDefault();
          this.scrollByPage(event.key === 'ArrowLeft' ? -1 : 1);
        };

        this.previousButton.addEventListener('click', this.handlePrevious);
        this.nextButton.addEventListener('click', this.handleNext);
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.track.addEventListener('keydown', this.handleKeydown);

        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
        this.updateControls();
      }

      disconnectedCallback() {
        if (!this.track) return;

        this.previousButton.removeEventListener('click', this.handlePrevious);
        this.nextButton.removeEventListener('click', this.handleNext);
        this.track.removeEventListener('scroll', this.handleScroll);
        this.track.removeEventListener('keydown', this.handleKeydown);
        this.resizeObserver?.disconnect();
      }

      scrollByPage(direction) {
        const card = this.track.querySelector('.royal-cats__card');
        if (!card) return;

        const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        const cardStep = card.getBoundingClientRect().width + gap;
        const visibleCards = Math.max(1, Math.floor(this.track.clientWidth / cardStep));

        this.track.scrollBy({ left: direction * cardStep * visibleCards, behavior: 'smooth' });
      }

      updateControls() {
        const maximumScroll = this.track.scrollWidth - this.track.clientWidth;
        const currentScroll = Math.abs(this.track.scrollLeft);

        this.previousButton.disabled = currentScroll <= 2;
        this.nextButton.disabled = currentScroll >= maximumScroll - 2;

        if (this.progressBar) {
          const progress = maximumScroll > 0 ? Math.min(1, currentScroll / maximumScroll) : 0;
          this.progressBar.style.setProperty('--royal-progress', progress.toFixed(3));
        }
      }
    }

    customElements.define('royal-categories-slider', RoyalCategoriesSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["royal-home-mobile-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('royal-search-categories')) {
    customElements.define('royal-search-categories', class extends HTMLElement {
      connectedCallback() {
        this.cleanup?.();
        const track = this.querySelector('[data-discover-track]');
        const previous = this.querySelector('[data-discover-prev]');
        const next = this.querySelector('[data-discover-next]');
        if (!track || !previous || !next) return;

        const update = () => {
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          const position = Math.min(maximum, Math.abs(track.scrollLeft));
          previous.disabled = position < 2;
          next.disabled = position >= maximum - 2;
        };

        const move = (direction) => track.scrollBy({
          left: direction * track.clientWidth * 0.8 * (getComputedStyle(track).direction === 'rtl' ? -1 : 1),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });

        const movePrevious = () => move(-1);
        const moveNext = () => move(1);

        previous.addEventListener('click', movePrevious);
        next.addEventListener('click', moveNext);
        track.addEventListener('scroll', update, { passive: true });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
        this.cleanup = () => {
          previous.removeEventListener('click', movePrevious);
          next.removeEventListener('click', moveNext);
          track.removeEventListener('scroll', update);
          this.resizeObserver.disconnect();
        };
        update();
      }

      disconnectedCallback() {
        this.cleanup?.();
        this.cleanup = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
